export const UseCases = {
  MARKETING: 'MARKETING',
  SALES: 'SALES',
  SERVICE: 'SERVICE'
};
export const AvailableUseCases = [UseCases.MARKETING, UseCases.SALES, UseCases.SERVICE];
export const useCasesQueryParamKey = 'useCases';

// TODO [HSoC]: Will be queried from BE as user selects use case
export const FEATURE_LIST = ['Help Desk', 'Customer Success', 'Knowledge Base', 'Feedback Surveys', 'Health Scores', 'SLAs'];